// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DrawerDragIndicator-base__YzaLP{display:flex;flex-shrink:0;align-items:center;justify-content:center;height:var(--size-6)}.DrawerDragIndicator-indicator__u1V5J{display:block;width:var(--size-10);height:var(--size-1);background-color:var(--gray-a7);border-radius:var(--border-radius-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "DrawerDragIndicator-base__YzaLP",
	"indicator": "DrawerDragIndicator-indicator__u1V5J"
};
export default ___CSS_LOADER_EXPORT___;
